module.exports = __webpack_public_path__ + "static/media/bindEnterprise2.c786fc12.png";